import { findArray } from 'helpers/utils';
import MirsTable from 'components/general/table/Table.js';
import Label from "components/general/Label";
import { useMemo } from 'react';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useViewport } from 'components/general/useViewPort';

const TeamStatisticsTeam = ({ data, stats, results }) => {
    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
    const tableColumns = useMemo(() =>
        [
            {
                id: 'TeamTotals',
                Header: <Label data={'HeaderMatch/TeamStats'} sport={mirs_discipline} />,
                accessor: 'code',
                className: 'text-start w-40',
                Cell: (props) => {
                    return (
                        <Label data={props.value} sport={mirs_discipline} />
                    )
                }
            },
            {
                id: 'Match',
                Header: <Label data='HeaderTeamMatch' />,
                headerClassName: "w-5 text-center",
                accessor: 'code',
                className: 'text-center',
                Cell: (props) => {
                    let match = findArray(data?.extendedInfos, { ei_code: [props.value] });
                    return (<TeamStatsType1 value={match?.ei_value} />)
                },
            },
            {
                id: 'Match1',
                Header: <><Label data='HeaderMatch' /> 1</>,
                headerClassName: "w-5 text-center",
                accessor: 'code',
                className: 'text-center',
                Cell: (props) => {
                    let m1 = findArray(results[0]?.data?.results?.extendedInfos, { ei_code: [props.value] })?.ei_value
                    return (<TeamStatsType1 value={m1} />)
                },
            },
            {
                id: 'Match2',
                Header: <><Label data='HeaderMatch' /> 2</>,
                headerClassName: "w-5 text-center",
                accessor: 'code',
                className: 'text-center',
                Cell: (props) => {
                    let m2 = findArray(results[1]?.data?.results?.extendedInfos, { ei_code: [props.value] })?.ei_value
                    return (<TeamStatsType1 value={m2} />)
                },
            },
            {
                id: 'Match3',
                Header: <><Label data='HeaderMatch' /> 3</>,
                headerClassName: "w-5 text-center",
                accessor: 'code',
                className: 'text-center',
                Cell: (props) => {
                    let m3 = findArray(results[2]?.data?.results?.extendedInfos, { ei_code: [props.value] })?.ei_value
                    return (<TeamStatsType1 value={m3} />)
                },
            },
            {
                id: 'Match4',
                Header: <><Label data='HeaderMatch' /> 4</>,
                headerClassName: "w-5 text-center",
                accessor: 'code',
                className: 'text-center',
                Cell: (props) => {
                    let m4 = findArray(results[3]?.data?.results?.extendedInfos, { ei_code: [props.value] })?.ei_value
                    return (<TeamStatsType1 value={m4} />)
                },
            },
            {
                id: 'Match5',
                Header: <><Label data='HeaderMatch' /> 5</>,
                headerClassName: "w-5 text-center",
                accessor: 'code',
                className: 'text-center',
                Cell: (props) => {
                    let m5 = findArray(results[4]?.data?.results?.extendedInfos, { ei_code: [props.value] })?.ei_value
                    return (<TeamStatsType1 value={m5} />)
                },
            },
        ], [data]
    )

    const tableColumnsSM = useMemo(() =>
        [
            {
                id: 'TeamTotals',
                Header: <Label data={'HeaderTeamMatchStats'} sport={mirs_discipline} />,
                accessor: 'code',
                className: 'text-start w-40',
                Cell: (props) => {
                    return (
                        <Label data={props.value} sport={mirs_discipline} />
                    )
                }
            },
            {
                id: 'Match',
                Header: '',
                headerClassName: "w-5 text-center",
                accessor: 'code',
                className: 'text-center',
                Cell: (props) => {
                    let match = findArray(data?.extendedInfos, { ei_code: [props.value] });
                    return (<TeamStatsType1 value={match?.ei_value} />)
                },
            },
        ]
    )

    const { breakPoint } = useViewport();
    let columns = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsSM : tableColumns

    return (
        <MirsTable
            id={`mirs-table-team-statistics-${mirs_rsc}`}
            data={stats}
            columns={columns}
            showLoading={false}
        />
    )
}

// SE MUESTRA SOLO UN VALOR '25'
function TeamStatsType1({ value }) {
    return (
        <>
            {value !== undefined ? value : ''}
        </>
    )
}
// SE MUESTRAN DOS VALORS '2/5' para Successful / Unsuccessful challenges
function TeamStatstype2({ value, lost }) {
    return (
        <>
            {value !== undefined ? value + '/' + lost : ''}
        </>
    )
}



export default TeamStatisticsTeam;